import {
  NumberField,
  BooleanField,
  SelectField,
  AsyncSelectField,
  DateField,
  StringField,
  ConstantField,
} from './BasicField';
import {
  DateRangeField,
  NumberRangeField,
  NumberSetField,
  TriStateField,
} from './MultiValueFields';
import { SegmentedField } from './SegmentedField';
import { StaticArrayField } from './StaticArrayField';
import { ArrayField } from './ArrayField';
import { ObjectField } from './ObjectField';
import { GroupField } from './GroupField';

export const FieldComponents = {
  number: NumberField,
  boolean: BooleanField,
  select: SelectField,
  asyncSelect: AsyncSelectField,
  date: DateField,
  dateRange: DateRangeField,
  numberRange: NumberRangeField,
  numberSet: NumberSetField,
  tristate: TriStateField,
  segmented: SegmentedField,
  staticArray: StaticArrayField,
  array: ArrayField,
  text: StringField,
  object: ObjectField,
  group: GroupField,
  constant: ConstantField,
};
